const STORAGE_KEY = "erp.pwa.install-hint-dismissed-at";
/** Через сколько дней подсказку об установке можно показать снова. */
const SNOOZE_DAYS = 14;

/**
 * Скрыл ли человек подсказку об установке. В хранилище лежит только время
 * скрытия — ни сессий, ни персональных данных, — а само хранилище может быть
 * недоступно (приватное окно), тогда подсказка просто показывается снова.
 */
export function isInstallHintSnoozed(now = Date.now()): boolean {
  try {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));

    return (
      Number.isFinite(stored) &&
      stored > 0 &&
      now - stored < SNOOZE_DAYS * 86_400_000
    );
  } catch {
    return false;
  }
}

export function snoozeInstallHint(now = Date.now()): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(now));
  } catch {
    // Хранилище недоступно: подсказка вернётся при следующем запуске.
  }
}
